
<app-table [items]="items$.getValue()" (sort)="sortData($event)" [tableConfig]="tableConfig" (select)="selectRows($event)" (goTo)="goToRow($event)" />

<div #bottomTag></div>

<app-spinner *ngIf="loading$ | async"></app-spinner>
